/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("TopMenuCommandWidget", ["TextWidgetBase", "WidgetFactory"], function (context, cls) {
  /**
   * TopMenuCommand widget.
   * @class TopMenuCommandWidget
   * @memberOf classes
   * @extends classes.TextWidgetBase
   * @publicdoc Widgets
   */
  cls.TopMenuCommandWidget = context.oo.Class(cls.TextWidgetBase, function ($super) {
    return /** @lends classes.TopMenuCommandWidget.prototype */ {
      __name: "TopMenuCommandWidget",
      /** @type {classes.ImageWidget} */
      _image: null,
      /** @type {HTMLElement} */
      _anchorElement: null,
      /** @type {HTMLElement} */
      _commentContainer: null,

      /**
       * @inheritDoc
       */
      _initElement: function (initialInformation) {
        this._ignoreLayout = true;
        $super._initElement.call(this, initialInformation);

        this._image = cls.WidgetFactory.createWidget("Image", this.getBuildParameters());
        this._image.setParentWidget(this);
        this._image.setAutoScale(true);
        cls.DOMElementHelper.prependChild(this._element, this._image.getElement());

        this._anchorElement = this._element.querySelector("span.anchor");
        this._commentContainer = this._element.querySelector("span.gbc-label-comment-container");

        cls.DOMElementHelper.on(this._element, "mouseover.TopMenuCommandWidget", this._onMouseover.bind(this));
      },

      /**
       * @inheritDoc
       */
      destroy: function () {
        if (this._element) {
          cls.DOMElementHelper.off(this._element, "mouseover.TopMenuCommandWidget");
        }
        if (this._image) {
          this._image.destroy();
          this._image = null;
        }
        $super.destroy.call(this);
      },

      /**
       * @inheritDoc
       */
      manageMouseClick: function (domEvent) {
        if (this.isEnabled() || this.isInterruptable()) {
          this.emit(context.constants.widgetEvents.click, domEvent);
          cls.DropDownWidget.hideAll(); // TODO why we not close all drop down when we send an Action to DVM
          return false;
        }
        return $super.manageMouseClick.call(this, domEvent);
      },

      /** @inheritDoc */
      _ariaDisabledExposed: true,

      /**
       * @inheritDoc
       */
      getDOMTabIndexElements: function () {
        return [this._element];
      },

      /**
       * Hide previous sub menu displayed from a same level topmenugroup
       * @param event
       * @private
       */
      _onMouseover: function (event) {
        cls.DropDownWidget.hideAll(event.target);
      },

      /**
       * Set the text of the command item
       * @param {string} text - text to display
       * @publicdoc
       */
      setText: function (text) {
        this._setTextContent(text, "_anchorElement");
        this._labelText = text || null;
        this._refreshAccessibleName();
      },

      /**
       * Set a comment for the Command item
       * @param {string} comment - accelerator name
       * @publicdoc
       */
      setComment: function (comment) {
        const regex = /([^A-Za-z]*\+|\-)([A-Za-z])$/g;
        if (window.browserInfo.isSafari) {
          comment = comment
            .replaceAll(/control/gi, "⌘")
            .replaceAll(regex, function (match) {
              return match.toUpperCase();
            })
            .replace("-", " ");
        } else {
          comment = comment
            .replace("-", "+")
            .replaceAll(/control/gi, "Ctrl")
            .replaceAll(regex, function (match) {
              return match.toUpperCase();
            });
        }
        this._commentContainer.textContent = comment;
      },

      /**
       * Get the text of the command item
       * @return {string} - text of the command item
       * @publicdoc
       */
      getText: function () {
        return this._anchorElement.textContent;
      },

      /**
       * Define the topmenu command image
       * @param {string} image - url source of the image
       * @publicdoc
       */
      setImage: function (image) {
        this._image.setSrc(image);
      },

      /**
       * Get image of the topmenu command
       * @return {?string} - source of the image, null if not set
       * @publicdoc
       */
      getImage: function () {
        if (this._image) {
          return this._image.getSrc();
        }
        return null;
      },

      /**
       * Set Default TTF color
       * @param {string} color - rgb formatted or css name
       */
      setDefaultTTFColor: function (color) {
        this.setStyle(".gbc_ImageWidget svg", {
          fill: color
        });
      }
    };
  });
  cls.WidgetFactory.registerBuilder("TopMenuCommand", cls.TopMenuCommandWidget);
});
